<template>
	<div :style="getStyle" class="t-form-group">
		<div v-if="showHeader" :class="$slots.header ? '' : 't-form-group-header'">
			<slot name="header">
				{{title}}
			</slot>
		</div>
		<div :class="{horizontal: horizontal, minwidth: useMinWidth}" :style="getGridStyle" class="t-form-group-content">
			<slot/>
		</div>
	</div>
</template>

<script>
export default {
	name: 'TFormGroup',
	props: {
		title: String,
		horizontal: Boolean,
		useMinWidth: Boolean,
		rowGap: String,
		columnGap: String,
		marginTop: String,
		marginBottom: String,
	},
	computed: {
		showHeader() {
			return Boolean(this.$slots['header']) || this.title;
		},
		getStyle() {
			return {
				marginBottom: this.marginBottom,
				marginTop: this.marginTop,
			};
		},
		getGridStyle() {
			return {
				gridRowGap: this.rowGap,
				gridColumnGap: this.columnGap,
			};
		}
	}
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';
.t-form-group {
	width: 100%;
}

.t-form-group-header {
	user-select: none;
	font-size: 11px;
	font-weight: 600;
	line-height: 1.45;
	letter-spacing: 0.3px;
	color: get-color($text, 'dark');
	text-transform: uppercase;
	margin-bottom: 8px;
	margin-left: 1px;
}

.t-form-group-content {
	display: grid;
	column-gap: 5px;
	row-gap: 10px;
	&.horizontal {
		grid-auto-flow: column;
		grid-auto-columns: 1fr;
		&.minwidth {
			grid-auto-columns: minmax(min-content, max-content);
		}
	}
	&:not(.horizontal) {
		grid-template-columns: 100%;
	}
}
</style>
